module.exports = __webpack_public_path__ + "img/toAllocatedE.6c24bcb1.png";